const Title = ({children}) => (
    <h1 className="text-3xl pb-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">{children}</h1>
)

export default Title;